import React from "react";

import { m as motion, AnimationFeature, MotionConfig } from "framer-motion2";

const FramerMotionWrapper = ({ children, ...props }) => {
  return (
    <MotionConfig features={[AnimationFeature]}>
      <motion.div
        id="player_main_row"
        animate={props.mainPlayerCSS}
        transition={{ duration: 1 }}
        style={{
          position: props.mainRowPosition,
        }}
      >
        {children}
      </motion.div>
    </MotionConfig>
  );
};

export default FramerMotionWrapper;
